/* eslint-disable react/prop-types */
import React, { useState } from 'react';

/**
 * Citation chips / accordion for rag_qa answers.
 * citations: [{ source, snippet?, title? }]
 */
const SpacerLogAiCitations = ({ citations }) => {
  const [open, setOpen] = useState(true);
  const list = Array.isArray(citations) ? citations.filter(Boolean) : [];
  if (!list.length) return null;

  return (
    <div className="spacer-log-ai-citations">
      <button
        type="button"
        className="spacer-log-ai-citations__toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        Sources ({list.length}) {open ? '▾' : '▸'}
      </button>
      {open ? (
        <ul className="spacer-log-ai-citations__list">
          {list.map((c, i) => {
            const label = c.source || c.title || c.documentName || `Source ${i + 1}`;
            const snippet = c.snippet || c.text || c.excerpt || '';
            return (
              <li key={`${label}-${i}`} className="spacer-log-ai-citations__item">
                <span className="spacer-log-ai-citations__chip">{label}</span>
                {snippet ? <p className="spacer-log-ai-citations__snippet">{snippet}</p> : null}
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
};

export default SpacerLogAiCitations;
